import NotificationsRequest from '@/components/NotificationsRequest';
import { GolfGameLiveData } from '@/plugins/live-activity';
import { liveActivityService } from '@/utils/liveActivityService';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Camera, CameraResultType } from '@capacitor/camera';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonLabel,
  IonList,
  IonModal,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const DebugPage: React.FC = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState<string>('general');
  const [activityId, setActivityId] = useState<string | undefined>(undefined);
  const [permissionsResult, setPermissionsResult] = useState<string | null>(null);
  const [showNotificationsRequest, setShowNotificationsRequest] = useState<boolean>(false);

  // Test Camera functionality
  const testCamera = async () => {
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.Uri,
      });
    } catch (error) {
      console.error('Error accessing camera:', error);
    }
  };

  // Test Firebase Messaging Permissions
  const checkMessagingPermissions = async () => {
    try {
      const permissionStatus = await FirebaseMessaging.checkPermissions();
      setPermissionsResult(JSON.stringify(permissionStatus, null, 2));
    } catch (error) {
      console.error('Error checking messaging permissions:', error);
      setPermissionsResult(JSON.stringify({ error: error instanceof Error ? error.message : 'Unknown error' }, null, 2));
    }
  };

  const testVibration = async () => {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      console.error('Error triggering haptics:', error);
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/dashboard" />
          </IonButtons>
          <IonTitle>Debug</IonTitle>
        </IonToolbar>
        <IonToolbar>
          <IonSegment value={activeTab} onIonChange={(e) => setActiveTab(e.detail.value as string)}>
            <IonSegmentButton value="general">
              <IonLabel>General</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="ios">
              <IonLabel>iOS</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        {activeTab === 'general' && (
          <IonList>
            <IonButton className="w-full" onClick={testCamera}>
              Test Camera
            </IonButton>
            <IonButton className="w-full" onClick={testVibration}>
              Test Vibration
            </IonButton>
            <IonButton className="w-full" onClick={() => history.push('/welcome')}>
              (BROKEN) Redo Onboarding
            </IonButton>
            <IonButton className="w-full" onClick={checkMessagingPermissions}>
              Check Firebase Messaging Permissions
            </IonButton>
            <IonButton className="w-full" onClick={() => setShowNotificationsRequest(true)}>
              Force request notification permission
            </IonButton>
            <IonButton className="w-full" onClick={() => window.location.reload()}>
              Restart app
            </IonButton>
            <IonButton className="w-full" routerLink="/sentry-test">
              Sentry test
            </IonButton>
            <IonButton className="w-full" routerLink="/play">
              DEBUG Test playgame map
            </IonButton>
            {permissionsResult && (
              <div className="mt-4 p-4 border-input border rounded overflow-auto">
                <pre>{permissionsResult}</pre>
              </div>
            )}
          </IonList>
        )}

        {activeTab === 'ios' && (
          <IonList>
            <IonButton className="w-full" onClick={async () => {
              const testGameData: GolfGameLiveData = {
                gameName: 'Test Game',
                playerName: 'Test Player',
                currentHole: 1,
                totalHoles: 18,
                par: 4,
                score: 4,
                courseName: 'Test Course',
                courseLayout: 'Standard'
              };
              const id = await liveActivityService.startLiveActivity(testGameData);
              setActivityId(id);
            }}>
              Start Live Activity
            </IonButton>
            <IonButton className="w-full" onClick={async () => {
              if (!activityId) return;
              const testGameData: GolfGameLiveData = {
                gameName: 'Test Game',
                playerName: 'Test Player',
                currentHole: 2,
                totalHoles: 18,
                par: 4,
                score: 4,
                courseName: 'Test Course',
                courseLayout: 'Standard'
              };
              await liveActivityService.updateLiveActivity(testGameData, activityId);
            }}>
              Update Live Activity
            </IonButton>
            <IonButton className="w-full" onClick={async () => {
              await liveActivityService.endLiveActivity(activityId);
              setActivityId(undefined);
            }}>
              End Live Activity
            </IonButton>
            {activityId && (
              <div className="mt-4 p-4 border-input border rounded">
                <p>Current Activity ID: {activityId || 'No activity in progress'}</p>
              </div>
            )}
          </IonList>
        )}
      </IonContent>

      <IonModal isOpen={showNotificationsRequest}>
        <NotificationsRequest
          onConfirm={() => setShowNotificationsRequest(false)}
          onCancel={() => setShowNotificationsRequest(false)}
        />
      </IonModal>
    </IonPage>
  );
};

export default DebugPage;